/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019-2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

angular.module('bulbApp.assetLibraryModule')
  .constant('UNSPLASH_PAGE_SIZE', 30)
  .service(
    'BulbAssetLibraryUnsplashService',
    ['$q', '$translate', 'BulbAssetLibraryService', 'BulbBusyCoverService', 'BulbErrorService',
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      'Restangular', 'UNSPLASH_PAGE_SIZE', BulbAssetLibraryUnsplashService,
    ],
  );
function BulbAssetLibraryUnsplashService(
  $q,
  $translate,
  BulbAssetLibraryService,
  BulbBusyCoverService,
  BulbErrorService,
  Restangular,
  UNSPLASH_PAGE_SIZE,
) {
  const that = this;

  // Variable to be used as callback function.
  let thisSelectHandler: (arg0: any) => void;

  // ==============================
  // REST API call
  // ==============================
  const assetlibrary = Restangular.all('assetlibrary');

  /**
   * Initialize Unsplash Picker and set select handler.
   * @param selectHandler callback function.
   */
  this.initializeUnsplashPhotoPicker = function initializeUnsplashPhotoPicker(selectHandler) {
    thisSelectHandler = selectHandler;
  };

  /**
   * Call when photo is selected from picker.
   * @param photoId - Unique id for photo.
   */
  this.selectPhoto = function selectPhoto(photoId) {
    thisSelectHandler(photoId);
  };

  /**
   * Method to search image.
   * @param keyword search string.
   * @param page - page number.
   */
  this.searchPhoto = function searchPhoto(keyword, page) {
    const deferred = $q.defer();
    assetlibrary.all('unsplash').all('search')
      .customGET('', {
        query: escape(keyword),
        pageSize: UNSPLASH_PAGE_SIZE,
        page,
      })
      .then((response) => deferred.resolve(response))
      .catch((err) => {
        const key = that.isErrorUnsplashTimeOut(err) || 'assetlibrary_unsplash_photos_search_error';
        BulbErrorService.showError($translate.instant(key), err);
        deferred.reject();
      });
    return deferred.promise;
  };

  /**
   * Method to update view count.
   *
   * @param photoId id of photo.
   */
  this.updateViewCount = function updateViewCount(photoId) {
    const deferred = $q.defer();
    assetlibrary.one('unsplash/updateViewCount')
      .customPOST({}, '', {
        photoId,

      })
      .then((response) => deferred.resolve(response))
      .catch(() => deferred.reject('View count update failed'));
    return deferred.promise;
  };

  this.importFromUnsplash = function importFromUnsplash(photoId, folderId) {
    const returnValue = assetlibrary.all('unsplash').all('upload').post('', {
      photoId,
      folderId,
    }).catch(that.errorFn);
    return returnValue;
  };

  /**
   * Handle error response.
   *
   * @param res Error Response Object.
   */
  this.errorFn = function errorFn(res) {
    const timeoutErrorKey = that.isErrorUnsplashTimeOut(res);
    if (timeoutErrorKey) {
      BulbAssetLibraryService.dialog.showError(timeoutErrorKey);
    } else if (res.data && res.data.developerMessage) {
      BulbAssetLibraryService.dialog.showError(res.data.message);
    } else {
      BulbAssetLibraryService.dialog.showError('unknown_error');
    }
  };

  /**
   * Return key if unsplash api response with timeout.
   *
   * @param error Error object.
   */
  this.isErrorUnsplashTimeOut = function isErrorUnsplashTimeOut(error) {
    if (error.data && error.data.developerMessage && error.data.developerMessage.includes('timed out')) {
      return 'assetlibrary_unsplash_api_timeout_error';
    }
  };

  this.unsplashPhotoSelectionHandler = function unsplashPhotoSelectionHandler(
    photoId: string,
    currentFolderId: string,
    onClose: Function,
  ) {
    BulbBusyCoverService.showBusyDuring(
      that.importFromUnsplash(photoId, currentFolderId).then(
        (restAngularResp) => {
          onClose(restAngularResp);
          BulbAssetLibraryService.dialog.closeCurrentModal();
        },
      ),
    );
  };

  this.openUnsplashImagePicker = function openUnsplashImagePicker(
    currentFolderId: string,
    onClose: Function = () => {},
  ) {
    const modalOption = {
      titleCode: 'assetlibrary_modal_use_image_title',
      template: '<bulb-asset-library-unsplash></bulb-asset-library-unsplash>',
      windowClass: 'bulb-assetlibrary-selection-modal bulb-unsplash-image-search bulb-unsplash-search-results',
      closeOnClick: true,
      showOkButton: false,
      showCancelButton: false,
    };
    that.initializeUnsplashPhotoPicker((photoId: string) => {
      that.unsplashPhotoSelectionHandler(photoId, currentFolderId, onClose);
    });
    BulbAssetLibraryService.dialog.show(modalOption, null);
  };
}
